<template lang="pug">
  app-page(title="Мой календарь" :loading="updating" :fab-items="fabItems")
    calendar-toolbar
    .text-right
      v-chip.ma-2(v-if="tag" color="#757575" text-color="white" small label close @click:close="setTag(null)") Тег:&nbsp;<b>{{ tag.hashtag }}</b>
    
    calendar-month(v-if="period.type.isMonth")
    calendar-week(v-if="period.type.isWeek")

    calendar-event-form(:event="selectedEvent")

    CalendarEventTagForm(v-model="dialog.editTag")
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import CalendarMonth from './components/CalendarMonth'
import CalendarWeek from './components/CalendarWeek'
import CalendarEventForm from './components/CalendarEventForm'
import CalendarToolbar from './components/CalendarToolbar'
import CalendarEventTagForm from './components/CalendarEventTagForm'

export default {
  data () {
    return {
      dialog: {
        editTag: false,
      }
    }
  },
  components: {
    CalendarMonth, CalendarWeek, CalendarEventForm, CalendarToolbar, CalendarEventTagForm
  },

  mounted () {
    this.$store.dispatch('event/init')
  },

  computed: {
    ...mapState('event', ['period', 'updating', 'selectedEvent', 'tag', 'tags']),

    fabItems () {
      return [
        { icon: 'event', title: 'Событие', action: () => this.createEmptyEvent() },
        { icon: 'edit', title: 'Цвет тега', action: () => this.dialogEditTag() }
      ]
    }
  },

  methods: {
    ...mapMutations('event', ['createEmptyEvent', 'setTag']),
    
    dialogEditTag () {
      this.dialog.editTag = true
    },
  }
}
</script>

<style scoped>
.event-action {
  margin: 0px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  color: #FFFFFF;
}
</style>